import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Typography, Button, Card, Space } from 'antd';
import {
  FileTextOutlined,
  CodeOutlined,
  TeamOutlined,
  CustomerServiceOutlined,
  GiftOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import CustomLayout from '../../layouts/Customlayout';

const { Title, Paragraph, Text } = Typography;

export default function WelcomePage() {
  const navigate = useNavigate();

  const handleCustomizeClick = () => {
    navigate('/user/settings');
  };

  return (
    <CustomLayout>
      <div style={{ padding: 24 }}>
        <Title level={4} style={{ textAlign: 'center', marginBottom: 16 }}>
          Welcome Tutorial
        </Title>

        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/zDCXtYggvUk"
            title="Tutorial Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <Paragraph>
            First thing you want to do is customize your chatbot.
          </Paragraph>
          <Button type="primary" onClick={handleCustomizeClick}>
            Go to Chatbot Settings
          </Button>
        </div>

      </div>
    </CustomLayout>
  );
}
